import ko from "knockout";
import $ from "jquery";
import register from "flow/knockout/register";

register.registerKnockoutBinding("sideTabHeight", {
    init: function (element) {
        const prevTabs = $(element).prev();
        if (prevTabs.length > 0) {
            const top = prevTabs.first().position().top;
            let usedHeight = 0;

            $(element)
                .prev()
                .each(function (_index, tab) {
                    usedHeight += $(tab).outerHeight(true);
                });
            $(element).css("top", top + usedHeight);
        }
    },
    update: function (_element, valueAccessor) {
        //For update to trigger
        ko.unwrap(valueAccessor());
    }
});
